export const unwrapApiResponse = async (res) => {
  const payload = await res.json().catch(() => ({}));

  if (!res.ok || payload?.success === false) {
    throw new Error(payload?.error || payload?.message || `Error ${res.status}`);
  }

  return payload && "data" in payload ? payload.data : payload;
};

export default unwrapApiResponse;